const API_BASE_URL =
  process.env.VUE_APP_API_URL ||
  'https://shatova.art/api'

export default API_BASE_URL
